import React from "react";
import { connect } from "react-redux";
import { changeEtapas } from "../actions";
//import { changeTabIndex } from "../../../Header/actions";

class EtapasPlanMovilidad extends React.PureComponent {
  checkItem = (e) => {
    this.props.dispatch(changeEtapas(e.itemData.contentId));
  }

  render() {
    return (
      <div id="MENU_ETAPAS_PLAN_MOVILIDA">
        {/* <section id="breadcrumb">
          <ol className="PM-breadcrumb-plan s1">
            <li className="PM-breadcrumb-item PM-breadcrumb-item-p" onClickCapture={() => { this.props.dispatch(changeTabIndex(0, 0)); }} style={{ cursor: "pointer" }}><i className="achs-icon" style={{ marginTop: -10, fontSize: 30 }}>A</i> / </li>
            <li className="PM-breadcrumb-item active PM-breadcrumb-item-p"> {this.props.etapaTitle}</li>
          </ol>
        </section> */}
        <React.Fragment>
          {this.props.etapaTabs &&
          <section id="breadcrumb-plan-etapa">
            <div className="container-fluid">
              <div className="row PM-plan-borde-spacing-2">
                <div className="col-sm-1 ">
                  {/* <div className="PM-section-title col-sm-12">{this.props.etapaTitle}</div>
                  { !this.props.esEncargado? <div className="col-sm-12 PM-plan-solo-lectura">Solo lectura</div> : null } */}
                </div>
                <div className="col-sm">
                  {
                    (this.props.ultimoEstadoProceso === 1) ?
                      <ul className="PM-progressbar">
                        <li onClickCapture={() => { this.props.dispatch(changeEtapas(0)); }} className="active-actual" style={{ cursor: "pointer" }}>Sensibilización</li>
                        <li onClickCapture={() => { this.props.dispatch(changeEtapas(1)); }} style={{ cursor: "pointer" }}>Diagnóstico</li>
                        <li onClickCapture={() => { this.props.dispatch(changeEtapas(2)); }} style={{ cursor: "pointer" }}>Plan de acción</li>
                        <li onClickCapture={() => { this.props.dispatch(changeEtapas(3)); }} style={{ cursor: "pointer" }}>Ejecución y seguimiento</li>
                      </ul>
                      :
                      (this.props.ultimoEstadoProceso === 2) ?
                        <ul className="PM-progressbar">
                          <li onClickCapture={() => { this.props.dispatch(changeEtapas(0)); }} className="active" style={{ cursor: "pointer" }}>Sensibilización</li>
                          <li onClickCapture={() => { this.props.dispatch(changeEtapas(1)); }} className="active-actual" style={{ cursor: "pointer" }}>Diagnóstico</li>
                          <li onClickCapture={() => { this.props.dispatch(changeEtapas(2)); }} style={{ cursor: "pointer" }}>Plan de acción</li>
                          <li onClickCapture={() => { this.props.dispatch(changeEtapas(3)); }} style={{ cursor: "pointer" }}>Ejecución y seguimiento</li>
                        </ul>
                        :
                        (this.props.ultimoEstadoProceso === 3) ?
                          <ul className="PM-progressbar">
                            <li onClickCapture={() => { this.props.dispatch(changeEtapas(0)); }} className="active" style={{ cursor: "pointer" }}>Sensibilización</li>
                            <li onClickCapture={() => { this.props.dispatch(changeEtapas(1)); }} className="active" style={{ cursor: "pointer" }}>Diagnóstico</li>
                            <li onClickCapture={() => { this.props.dispatch(changeEtapas(2)); }} className="active-actual" style={{ cursor: "pointer" }}>Plan de acción</li>
                            <li onClickCapture={() => { this.props.dispatch(changeEtapas(3)); }} style={{ cursor: "pointer" }}>Ejecución y seguimiento</li>
                          </ul>
                          :
                          (this.props.ultimoEstadoProceso === 4) ?
                            <ul className="PM-progressbar">
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(0)); }} className="active" style={{ cursor: "pointer" }}>Sensibilización</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(1)); }} className="active" style={{ cursor: "pointer" }}>Diagnóstico</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(2)); }} className="active" style={{ cursor: "pointer" }}>Plan de acción</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(3)); }} className="active-actual" style={{ cursor: "pointer" }}>Ejecución y seguimiento</li>
                            </ul>
                            :
                            <ul className="PM-progressbar">
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(0)); }} style={{ cursor: "pointer" }}>Sensibilización</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(1)); }} style={{ cursor: "pointer" }}>Diagnóstico</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(2)); }} style={{ cursor: "pointer" }}>Plan de acción</li>
                              <li onClickCapture={() => { this.props.dispatch(changeEtapas(3)); }} style={{ cursor: "pointer" }}>Ejecución y seguimiento</li>
                            </ul>
                  }
                </div>
                <div className="col-sm-1"></div>
              </div>
            </div>
          </section>
          }
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  etapaTitle: state.planMovilidad.etapaTitle,
  etapaTabs: state.planMovilidad.etapaTabs,
  etapaPosition: state.planMovilidad.etapaPosition,
  estadoProceso: state.planMovilidad.estadoProceso,
  ultimoEstadoProceso: state.planMovilidad.ultimoEstadoProceso,
  listaContenidos: state.planMovilidad.listaContenidos,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EtapasPlanMovilidad);
